<template>
  <v-container>
    <dialog-restore-password ref="DialogRestorePassword" />

    <v-layout text-center wrap>
      <v-flex xs12>
        <v-container class="fill-height" fluid>
          <v-row align="center" justify="center">
            <v-col cols="12" sm="8" md="4">
              <v-card class="elevation-12">
                <v-toolbar color="primary" dark>
                  <v-toolbar-title>{{$t("LoginPage.toolbarTitle")}}</v-toolbar-title>
                  <div class="flex-grow-1"></div>
                </v-toolbar>
                <v-card-text>
                  <v-form v-model="valid">
                    <v-text-field
                        :label="$t('LoginPage.loginLabel')"
                        name="login"
                        prepend-icon="mdi-account"
                        type="email"
                        v-model="Login"
                        :rules="[validRequired, validEmail]"
                    ></v-text-field>

                    <v-text-field
                        :append-icon="PasswShow ? 'mdi-eye' : 'mdi-eye-off'"
                        :type="PasswShow ? 'text' : 'password'"
                        @click:append="PasswShow = !PasswShow"
                        prepend-icon="mdi-lock"
                        id="password"
                        :label="$t('LoginPage.PasswordLabel')"
                        name="password"
                        v-model="Password"
                        :rules="[validRequired, validLength8chars]"
                    ></v-text-field>
                  </v-form>
                </v-card-text>
                <v-card-actions>
                  <v-btn color="primary" text x-small @click="btnRegistration()">
                    {{$t("LoginPage.btnRegistrationTitle")}}
                  </v-btn>
                  |
                  <v-btn class="ml-0" color="primary" text x-small @click="btnResetPassword()">
                    {{$t("LoginPage.btnResetPasswordTitle")}}
                  </v-btn>

                  <div class="flex-grow-1"></div>
                  <v-btn :disabled="!valid" color="primary" @click="btnLogin()">{{$t("LoginPage.btnLoginTitle")}}</v-btn>
                </v-card-actions>
              </v-card>
            </v-col>
          </v-row>
        </v-container>

      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import DialogRestorePassword from "@/components/dialogs/auth/DialogRestorePassword"
import {mapActions} from "vuex"

export default {
  name: "LoginPage",
  components:{DialogRestorePassword},
  data: () => ({
    valid: false,
    Login:'',
    Password:'',
    PasswShow: false,
  }),
  methods: {
    ...mapActions('common',["apiBackendLogin","apiBackendRestore"]),

    async btnResetPassword(){
      console.log(`btnResetPassword()`)
      const result = await this.$refs.DialogRestorePassword.show({})
      if (result.answer === "positive") {
        console.log('ResetPassword', result.email)
        await this.apiBackendRestore({email: result.email})
      }
    },

    btnLogin(){
      //console.log('btnLogin')
      this.apiBackendLogin({ login: this.Login, password: this.Password})
    },

    btnRegistration(){
      console.log(`btnRegistration`)
      this.$router.push({name: 'RegistrationPage'})
    },

    validRequired(v) {
      return !!v || this.$t("LoginPage.validRequiredTitle")
    },

    validEmail(v) {
      return /.+@.+\..+/.test(v) || this.$t("LoginPage.validEmailTitle")
    },

    validLength8chars(v) {
      return v.length >= 8 || this.$t("LoginPage.validLength8charsTitle")
    },

  },
  computed:{
   },

  created() {
  }
};
</script>
